module.exports = __webpack_public_path__ + "img/head.244be867.png";